@if (stock) {

  <form [formGroup]="stockForm"
        (ngSubmit)="saveStock()"
        autocomplete="off"
        novalidate>

    <div class="row">

      <div class="col-sm-6">

        <div class="form-group"
             [class.error]="statedShareValue.invalid && (statedShareValue.dirty || statedShareValue.touched || mouseoverStockSubmit)">
          <span class="fake-label">Share Value</span>
          @if (statedShareValue.invalid && (statedShareValue.dirty || statedShareValue.touched || mouseoverStockSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="statedShareValue"
                 type="text"
                 name="statedShareValue"
                 class="form-control"
                 currencyMask
                 [options]="{ prefix: '$ ', thousands: ',', decimal: '.' }" />
        </div>

      </div>

      <div class="col-sm-6">

        <div class="form-group">
          <label for="statedValueNote" class="fake-label">Share Value Note</label>
          <input formControlName="statedValueNote"
                 type="text"
                 name="statedValueNote"
                 class="form-control text-right" />
        </div>

      </div>

    </div>

    <div class="row">

      <div class="col-sm-6">

        <div class="form-group"
             [class.error]="dividendPerShare.invalid && (dividendPerShare.dirty || dividendPerShare.touched || mouseoverStockSubmit)">
          <span class="fake-label">Dividend Per Share</span>
          @if (dividendPerShare.invalid && (dividendPerShare.dirty || dividendPerShare.touched || mouseoverStockSubmit)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="dividendPerShare"
                 type="text"
                 name="dividendPerShare"
                 class="form-control"
                 currencyMask
                 [options]="{ prefix: '$ ', thousands: ',', decimal: '.' }" />
        </div>

      </div>

      <div class="col-sm-6">

        <div class="form-group">
          <label for="dividendNote" class="fake-label">Dividend Note</label>
          <input formControlName="dividendNote"
                 type="text"
                 name="dividendNote"
                 class="form-control text-right" />
        </div>

      </div>

    </div>

    <div class="row mt-3">

      <div class="col text-center">

        <span (mouseenter)="mouseoverStockSubmit=true" (mouseleave)="mouseoverStockSubmit=false">
          <app-button [buttonConfig]="{textChange: ['Add', 'Update']}"
                      [textChangeIndex]="+(!!(stock.id))"
                      [isLoading]="isSubmitting"
                      [disabled]="!stockForm.valid || isSubmitting"
                      (textBtnClickEmt)="saveStock()"></app-button>
        </span>

      </div>

    </div>

  </form>

}
